import { render, staticRenderFns } from "./MultipleChoiceContent.vue?vue&type=template&id=53af7193&scoped=true&"
import script from "./MultipleChoiceContent.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceContent.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoiceContent.vue?vue&type=style&index=0&id=53af7193&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53af7193",
  null
  
)

export default component.exports